import React from "react";
import PropTypes from "prop-types";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText, Label } from "../../../../components/Inputs";
import { STATUS_IDS } from "../../../../components/Utils";

const getState = (model) => {
  const userData = model.userData || {};
  let roles = [];
  // if (model.froze_requested_roles) {
  //   try {
  //     roles = JSON.parse(model.froze_requested_roles);
  //     console.log("Parsed froze_requested_roles:", roles);
  //   } catch (error) {
  //     console.error("Error parsing froze_requested_roles:", error);
  //   }
  // }
  // if (roles.length === 0) {
  if (model.rolesData) {
    roles = model.rolesData;
  } else if (model.role_label) {
    roles.push({
      name: model.role_label,
      id: model.role_id,
      status_id: model.status_id,
    });
  }
  // }
  return {
    parentCompanyName: model.parentCompanyName,
    username: model.username || userData.vf_email || "",
    email: userData.email || "",
    ngumUserId: model.ngumUserId,
    roles,
  };
};

function ANPConnectionTaskForm({
  forwardedRef,
  className = "",
  model: originalModel = {
    parentCompanyName: "",
    username: "",
    roles: [],
    ngumUserId,
  },
  isUpdating = false,
  isDeleting = false,
}) {
  const getModel = React.useCallback(() => {
    const model = {
      ...originalModel,
      ...getState(originalModel),
    };
    return model;
  }, [originalModel]);
  React.useImperativeHandle(forwardedRef, () => ({
    getModel,
  }));

  const { parentCompanyName, username, email, roles, ngumUserId } =
    getState(originalModel);

  return (
    <div className={`${className} w3-large`}>
      <div className="w3-row neg-margin-lr">
        <div className="w3-col s12 pad-lr pad-top form-group-item">
          <Label>{`Vertragspartner`}</Label>
          <InputText
            className="w3-block w3-border w3-round pad"
            value={parentCompanyName}
            readonly
          />
        </div>
        <div className="w3-col s12 pad-lr pad-top form-group-item">
          <Label>{`Vodafone E-Mail Adresse`}</Label>
          <InputText
            className="w3-block w3-border w3-round pad"
            value={username}
            readonly
          />
        </div>
        <div className="w3-col s12 pad-lr pad-top form-group-item">
          <Label>{`nGUM User ID`}</Label>
          <InputText
            className="w3-block w3-border w3-round pad"
            value={ngumUserId || ""}
            readonly
          />
        </div>
        <div className="w3-col s12 pad-lr pad-top form-group-item">
          <Label>{`Externe E-Mail Adresse`}</Label>
          <InputText
            className="w3-block w3-border w3-round pad"
            value={email}
            readonly
          />
        </div>
        <div className="w3-col s12 pad-lr pad-big-top form-group-item">
          <RoleTable isChanging={isUpdating || isDeleting} roles={roles} />
        </div>
      </div>
    </div>
  );
}

ANPConnectionTaskForm.propTypes = {
  className: PropTypes.string,
  model: PropTypes.shape({
    userData: PropTypes.shape({
      vf_email: PropTypes.string,
      email: PropTypes.string,
    }),
    roles: PropTypes.arrayOf(PropTypes.string),
    rolesData: PropTypes.arrayOf(
      PropTypes.shape({
        role_id: PropTypes.number,
        name: PropTypes.string,
        status_id: PropTypes.number,
      }),
    ),
    status_id: PropTypes.number,
    status: PropTypes.string,
  }),
  isUpdating: PropTypes.bool.isRequired,
  isDeleting: PropTypes.bool,
};

export default React.forwardRef((props, ref) => (
  <ANPConnectionTaskForm {...props} forwardedRef={ref} />
));

function RoleTable({ isChanging, roles: originalRoles }) {
  const roles = originalRoles.map((role, index) => {
    let change = undefined;
    if (isChanging) {
      change = role.status_id === STATUS_IDS.NEW ? "Neu" : "Löschung";
    }
    return {
      ...role,
      index,
      change,
    };
  });
  return (
    <DataTable
      value={roles}
      paginator={roles.length > 10}
      rows={10}
      removableSort
      sortMode="multiple"
    >
      <Column field="name" header="AN-Portal Rollen" sortable />
      {isChanging && <Column field="change" header="Veränderung" sortable />}
    </DataTable>
  );
}

RoleTable.propTypes = {
  isChanging: PropTypes.bool,
  roles: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
    }),
  ),
};
